/**
 * Shared Socket.IO auth helpers for human-agent inbox connections.
 */
export async function hmacSha256Hex(secret, message) {
  if (!secret || !message || !window?.crypto?.subtle || typeof TextEncoder === "undefined") {
    return null;
  }
  const encoder = new TextEncoder();
  const key = await window.crypto.subtle.importKey(
    "raw",
    encoder.encode(secret),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  );
  const sig = await window.crypto.subtle.sign("HMAC", key, encoder.encode(message));
  return Array.from(new Uint8Array(sig))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
